module.exports = __webpack_public_path__ + "img/1.33378547.png";